import { CloseOutlined } from '@ant-design/icons'
import { CallReadable, ReturnShortCallReadable } from '@crm/api'
import { Button, Card, Flex } from 'antd'
import { useRef } from 'react'
import H5AudioPlayer from 'react-h5-audio-player'

import { Speed } from './Controls'
import { useStyles } from './styles'

type Props = {
  record: CallReadable | ReturnShortCallReadable
  onClose: () => void
  onPlay?: () => void
  onPause?: () => void
}

export const AudioPlayer = ({ record, onClose, onPlay, onPause }: Props) => {
  const { styles } = useStyles()

  const player = useRef<H5AudioPlayer>(null)

  const fileLegacyUrl =
    'file_legacy_url' in record
      ? record.file_legacy_url
      : record.attachment?.file

  return (
    <Card className={styles.playerContainer}>
      <Flex gap={10} id="audio-player-h5">
        <H5AudioPlayer
          autoPlay
          onPlay={onPlay}
          onPause={onPause}
          ref={player}
          src={fileLegacyUrl ?? undefined}
          customAdditionalControls={[<Speed key="speed" player={player} />]}
        />

        <Button
          type="text"
          shape="circle"
          onClick={onClose}
          icon={<CloseOutlined />}
        />
      </Flex>
    </Card>
  )
}
